import productPageChangePriceFromOption from '../../../public/catalog/view/theme/default/template/_components/productPage/productPageChangePriceFromOption';
import productPageRemoveFromCart from '../../../public/catalog/view/theme/default/template/_components/productPage/productPageRemoveFromCart';
import filterControlsOpenPopup from '../../../public/catalog/view/theme/default/template/_components/filterControls/filterControlsOpenPopup';
import greetingScreenButtonPosition from '../../../public/catalog/view/theme/default/template/_components/greetingScreen/greetingScreen';
import productInCartRemove from '../../../public/catalog/view/theme/default/template/_components/productInCart/productInCartRemove';
import productPageAddToCart from '../../../public/catalog/view/theme/default/template/_components/productPage/productPageAddToCart';
import productPageSetPrice from '../../../public/catalog/view/theme/default/template/_components/productPage/productPageSetPrice';
import categoryTileStates from '../../../public/catalog/view/theme/default/template/_components/categoryTile/categoryTileStates';
import searchFieldFocused from '../../../public/catalog/view/theme/default/template/_components/searchField/searchFieldFocused';
import headerPaddingForPage from '../../../public/catalog/view/theme/default/template/_components/header/headerPaddingForPage';
import searchFieldEraser from '../../../public/catalog/view/theme/default/template/_components/searchField/searchFieldEraser';
import productMouseHandler from '../../../public/catalog/view/theme/default/template/_components/product/productMouseHandler';
import searchFieldWidth from '../../../public/catalog/view/theme/default/template/_components/searchField/searchFieldWidth';
import contentRowIsSticky from '../../../public/catalog/view/theme/default/template/_components/content/contentRowIsSticky';
import popupCtrl from '../../../public/catalog/view/theme/default/template/_components/popupCtrl/popupCtrl';
import bannersHandler from '../../../public/catalog/view/theme/default/template/_components/banner/banner';
import formHandler from '../../../public/catalog/view/theme/default/template/_components/form/formHandler';
import cartHandlerHeaderBtnHandler from './functionsWithoutComponents/cartHandlerHeaderBtnHandler';
import numberValue from './freeElements/numberValue';
import goToId from '../../../public/catalog/view/theme/default/template/_components/goToId/goToId';

import pageCategoryViewSettings from '../../../public/catalog/view/theme/default/template/_components-24/page-category/pageCategoryViewSettings';
import formV2Handler from '../../../public/catalog/view/theme/default/template/_components-24/form/form-handler';
import order from '../../../public/catalog/view/theme/default/template/_components-24/order/order';
import pageProductPopupHandler
    from '../../../public/catalog/view/theme/default/template/_components-24/page-product-popup/page-product-popup-handler';

// Common functions
// ---
// Free elements
numberValue();
// Components
productPageChangePriceFromOption();
greetingScreenButtonPosition();
cartHandlerHeaderBtnHandler();
productPageRemoveFromCart();
filterControlsOpenPopup();
headerPaddingForPage();
productPageAddToCart();
productPageSetPrice();
productMouseHandler();
productInCartRemove();
categoryTileStates();
contentRowIsSticky();
searchFieldFocused();
searchFieldEraser();
searchFieldWidth();
bannersHandler();
formHandler();
popupCtrl();
goToId();

pageCategoryViewSettings();
pageProductPopupHandler();
formV2Handler();

order();
